/**
 * LyraKnowledgeBase — Admin
 * Wrapper 3 onglets : Documentation | Mémoire | Validation Drive
 */

import React, { useState } from 'react';
import { FileText, Brain, CloudDownload } from 'lucide-react';
import LyraDocumentManagement from './LyraDocumentManagement';
import LyraMemoryManagement from './LyraMemoryManagement';
import LyraPendingDocuments from './LyraPendingDocuments';

const TABS = [
  { id: 'documents', label: 'Documentation',     icon: FileText,      component: LyraDocumentManagement },
  { id: 'memory',    label: 'Mémoire',            icon: Brain,         component: LyraMemoryManagement },
  { id: 'pending',   label: 'Validation Drive',   icon: CloudDownload, component: LyraPendingDocuments },
];

const LyraKnowledgeBase = () => {
  const [activeTab, setActiveTab] = useState('documents');
  const ActiveComponent = TABS.find(t => t.id === activeTab)?.component;

  return (
    <div className="px-4 sm:px-6 lg:px-8 space-y-4">
      {/* Onglets */}
      <div className="flex gap-1 bg-gray-100 rounded-xl p-1">
        {TABS.map(tab => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex-1 flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium transition-all ${
                activeTab === tab.id
                  ? 'bg-white text-amber-600 shadow-sm'
                  : 'text-gray-500 hover:text-gray-700'
              }`}
            >
              <Icon size={14} />
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* Contenu */}
      {ActiveComponent && <ActiveComponent />}
    </div>
  );
};

export default LyraKnowledgeBase;
